import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./NavigationBar.css";
import whatsappIcon from "../assets/whatsapp.svg";

const links = [{ path: "/", label: "#HeartyEarth" }];

function NavigationBar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const activeLink =
    links.find((link) => link.path === location.pathname) || links[0];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navigation-bar">
      {/* === Expanded Navigation === */}
      <div className="navigation-container-expanded">
        {links.map((link) => (
          <div key={`expanded-${link.path}`} className="col-auto center-500">
            <NavLink
              to={link.path}
              className="navigation-button"
              onClick={() => setIsOpen(false)}
            >
              <button>{link.label}</button>
            </NavLink>
          </div>
        ))}

        {/* ✅ Latest News button (expanded) */}
        <div className="col-auto center-500">
          <NavLink
            to="/news"
            className="navigation-button"
            onClick={() => setIsOpen(false)}
          >
            <button className="secondary">Latest News</button>
          </NavLink>
        </div>

        <div className="col-auto center-500">
          <button
            className="secondary"
            onClick={() => window.open("https://wa.me/447887902412", "_blank")}
          >
            Get involved
            <img
              src={whatsappIcon}
              alt="whatsapp-icon"
              className="icon md-32 outlined"
            />
          </button>
        </div>

        <div className="col-auto center-500">
          <button
            className="secondary"
            onClick={() =>
              window.open(
                "https://sites.google.com/brookes.ac.uk/obbs-community-ambassadors/home",
                "_blank"
              )
            }
          >
            Become an Ambassador
            <i className="material-icons md-32 icon">open_in_new</i>
          </button>
        </div>
      </div>

      {/* === Condensed Navigation === */}
      <div className="navigation-container-condensed">
        <div
          className={`navigation-dropdown-container${isOpen ? " open" : ""}`}
          ref={dropdownRef}
        >
          <button
            className="navigation-button active"
            onClick={() => setIsOpen(!isOpen)}
          >
            {activeLink.label}
            <i className="material-icons md-40">arrow_drop_down</i>
          </button>

          {isOpen && (
            <div className="navigation-dropdown-list">
              {links.map((link) =>
                link !== activeLink ? (
                  <div key={`condensed-${link.path}`} className="col-auto center-500">
                    <NavLink
                      to={link.path}
                      className="navigation-button"
                      onClick={() => setIsOpen(false)}
                    >
                      <button>{link.label}</button>
                    </NavLink>
                  </div>
                ) : null
              )}

              {/* ✅ Latest News button (condensed) */}
              <div className="col-auto center-500">
                <NavLink
                  to="/news"
                  className="navigation-button"
                  onClick={() => setIsOpen(false)}
                >
                  <button className="secondary">Latest News</button>
                </NavLink>
              </div>

              <div className="col-auto center-500">
                <button
                  className="secondary"
                  onClick={() => window.open("https://wa.me/447887902412", "_blank")}
                >
                  Get involved
                  <img
                    src={whatsappIcon}
                    alt="whatsapp-icon"
                    className="icon md-32 outlined"
                  />
                </button>
              </div>

              <div className="col-auto center-500">
                <button
                  className="secondary"
                  onClick={() =>
                    window.open(
                      "https://sites.google.com/brookes.ac.uk/obbs-community-ambassadors/home",
                      "_blank"
                    )
                  }
                >
                  Ambassadors
                  <i className="material-icons md-32 icon">open_in_new</i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
